import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PPReasonList } from '../../../../components/admin-dashboard-component/partially-package-reasons/p-p-reason-list/p-p-reason-list';
import { AddIcon } from '../../../../shared/ui/icons/add-icon/add-icon';

@Component({
  selector: 'app-reasons-list',
  standalone: true,
  imports: [PPReasonList, AddIcon],
  templateUrl: './reasons-list.html',
  styleUrl: './reasons-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReasonsList {
  private router = inject(Router);

  navigateToAddReason() {
    this.router.navigate(['/admin/partially-package-reasons/add-reason']);
  }
}
